import React from 'react'
import { Button } from '@material-ui/core'
import { DownloadCSVPopup, PickAndMix, PickAndMixOption } from 'components'

export type DownloadCSVCustomFieldsProps = {
  buttonText?: string
  reportFileName: string
  enabled: boolean
  gsUrl: string
  fieldOptions: PickAndMixOption[]
  onDownload: (selectedFields: PickAndMixOption[]) => void
  onOpen: () => void
}

export const DownloadCSVCustomFields: React.FC<DownloadCSVCustomFieldsProps> = (
  props: DownloadCSVCustomFieldsProps
) => {
  const { buttonText = 'CSV Download All', reportFileName, enabled, gsUrl, fieldOptions, onDownload, onOpen } = props

  const [open, setOpen] = React.useState<boolean>(false)
  const [downloadModalOpen, setDownloadModalOpen] = React.useState<boolean>(false)
  const downloadDisabled = !enabled
  // Ensures modal doesn't open on re-render
  const [downloadInitiated, setDownloadInitiated] = React.useState<boolean>(false)

  React.useEffect(() => {
    if (downloadInitiated === true && gsUrl !== '') {
      setDownloadInitiated(false)
      setDownloadModalOpen(true)
    }
  }, [downloadInitiated, gsUrl])

  const handleDownload = (selectedFields: PickAndMixOption[]) => {
    if (gsUrl === '') {
      setDownloadInitiated(true)
      onDownload(selectedFields)
    } else {
      setDownloadModalOpen(true)
    }
  }

  return (
    <>
      <Button
        variant="text"
        disabled={downloadDisabled}
        className={`text-primary underline normal-case text-lg ${downloadDisabled ? 'opacity-50' : ''}`}
        onClick={() => {
          onOpen()
          setOpen(true)
        }}
      >
        {buttonText}
      </Button>
      <PickAndMix
        title={`Customised CSV Download All`}
        maxWidth={`sm`}
        cancelButtonText={`Cancel`}
        finishButtonText={`Download`}
        availableChoicesGroupName={`Report Fields`}
        selectedChoicesGroupName={`Selected CSV Fields`}
        open={open}
        onClose={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        options={fieldOptions}
        onFinish={handleDownload}
      />
      <DownloadCSVPopup
        open={downloadModalOpen}
        onClose={() => {
          setOpen(false)
          setDownloadModalOpen(false)
        }}
        reportFileName={reportFileName}
      />
    </>
  )
}
